import React from "react";
import styled from "styled-components";
import { flexCenter } from "../mixins";

const Spacer = styled.div`
    position: relative;
    margin: 80px auto 40px;
    ${flexCenter};
    text-align: center;
    text-transform: uppercase;

    &::before {
        content: "";
        position: absolute;
        top: -20px;
        left: 50%;
        transform: translateX(-50%);
        width: 40%;
        max-width: 60px;
        height: 4px;
        background-color: ${({ theme }) => theme.colors.black};
    }
`;

const Title = styled.div`
    display: inline-flex;
    padding: 0 20px;

    & > * {
        font-size: ${({ theme }) => theme.fz.XXL};
        font-weight: ${({ theme }) => theme.fw.semiBold};
    }

    @media screen and (max-width: 560px) {
        & > * {
            font-size: ${({ theme }) => theme.fz.L};
        }
    }
`;

const SpacerComponent = ({ children }) => (
    <Spacer>
        <Title>{children}</Title>
    </Spacer>
);
export default SpacerComponent;
